import React, { useContext, useEffect, useState, useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import ComingSoon from 'components/pages/ComingSoon';
import NavbarTop from 'components/navbar/top/NavbarTop';
import NavbarVertical from 'components/navbar/vertical/NavbarVertical';
import AppContext from 'context/Context';
import Footer from 'components/footer/Footer';
import classNames from 'classnames';
import { frontendRoutes } from 'router/routes';
import { MainLayout as textLang } from 'staticData/languages';
import { endpointInterface } from 'services/endpointInterface/endpointInterface';
import { endpointInterfaceV2 } from 'services/endpointInterface/endpointInterfaceV2';
import LoadingSpinner from '../components/utilities/LoadingSpinner';
import { toast } from 'react-toastify';
import maintenance from 'assets/img/animated-icons/maintenance.json';
import {
  teamLevel,
  maintenanceVariable,
  getFromLocalStorage,
  sharedState,
  coinImgMap,
  exchangeImgMap,
  traderClusterID,
  removeFromLocalStorage
} from 'staticData/common';
import 'assets/scss/custom/mainLayout.scss';
import NavbarBottom from 'components/navbar/bottom/NavbarBottom';
import Event from 'layouts/components/Event';
import Header from 'layouts/components/Header';
import HodlieRouter from 'router/HodlieRouter';
import UsetifulScriptLoader from 'services/externals/usetiful/ScriptLoader';
import { deepEqual } from 'helpers/utils';
import { initClarity } from 'services/externals/clarity';
import { banner_dashboard as isEventTime } from 'staticData/unlockTimers';
import Snowfall from 'react-snowfall';
import { setItemToStore } from 'helpers/utils';
import { useHistory } from 'react-router-dom';
import ClosingPage from 'pages/CLOSING/ClosingPage';

const MainLayout = () => {
  const {
    config: { isFluid, navbarPosition, lang },
    setUserInfos,
    userInfos,
    setLoggedIn,
    loggedIn
  } = useContext(AppContext);
  const isClosed = true;
  const { hash, pathname } = useLocation();
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  const isIOSStandalone = window.navigator.standalone;
  const pwa_env = getFromLocalStorage('pwa_env');
  const pwa_version = getFromLocalStorage('pwa_version');
  // Snowfall Part
  const loadedTime = useRef(0);
  const imagePaths = Object.values(coinImgMap);
  imagePaths.push(exchangeImgMap.Virtual);
  const images = imagePaths.map(path => {
    const img = document.createElement('img');
    img.src = path;
    return img;
  });

  var pathString = pathname;
  while (pathString.length > 1 && pathString.slice(-1) === '/') {
    pathString = pathString.slice(0, -1);
  }
  var subPath = pathString.split('/');
  subPath = subPath.slice(1).map(i => '/' + i.toLowerCase());
  const isKanban = pathname.includes('kanban');
  // maintenance Part
  const [isInMaintenance, setIsInMaintenance] = useState(false);
  const [isBackendDown, setIsBackendDown] = useState(false);
  const [loadedContent, setLoadedContent] = useState(false);
  const hideHeader = true;
  const [showHeader, setShowHeader] = useState(!hideHeader);
  const routerHistory = useHistory();

  var intervalBackendVersion;
  var checkMaintenance = false;
  var backendErrorCount = 0;

  // frontend routes
  var verticalNavPath = false;
  var topNavPath = false;
  var bottomNavPath = false;
  var credentialsPath = false;
  frontendRoutes.map(item => {
    subPath.map(path => {
      if (path === item.to.toLowerCase()) {
        verticalNavPath = item.navbarVertical;
        topNavPath = item.navbarTop;
        bottomNavPath = item.navbarBottom;
        credentialsPath = item.withCredentials;
        return;
      }
    });
  });

  const sendFirebaseToken = async () => {
    const firebaseToken = getFromLocalStorage('firebase-token');
    // send firebase token to backend
    if (firebaseToken) {
      await endpointInterfaceV2({
        internalEndpoint: 'firebaseSetToken',
        httpMethod: 'post',
        usingCredentials: true,
        bodyParams: {
          token: firebaseToken
        },
        showError: false
      });
      // remove firebase token from local storage
      removeFromLocalStorage('firebase-token');
    }
  };

  const requestDataFromMaui = () => {
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.mauiBridge
    ) {
      // iOS
      window.webkit.messageHandlers.mauiBridge.postMessage('getPlatform');
      window.webkit.messageHandlers.mauiBridge.postMessage(
        'getNotificationsToken'
      );
    }
  };

  useEffect(() => {
    requestDataFromMaui();
  }, []);

  // GET Platform
  window.__platform = function (platform) {
    // set platform to local storage (get data from native app)
    setItemToStore('pwa_env', platform.toUpperCase());
  };
  // Apple sign in
  window.__receiveAppleSignInToken = function (token) {
    // send Apple login token to the backend
    if (token && token.toLowerCase() !== 'error')
      window.sendLoginToken({ credential: token }, 'appleLogin');
  };
  // Google sign in
  window.__receiveGoogleSignInToken = function (token) {
    // send Google login token to the backend
    if (token && token.toLowerCase() !== 'error')
      window.sendLoginToken({ credential: token }, 'googleLogin');
    else routerHistory.push('/login');
  };
  // Notification
  window.__receiveNotificationsToken = function (token) {
    // set the notification token to the local storage
    setItemToStore('firebase-token', token);
  };

  const checkBackendMaintenance = async () => {
    let backendResponse = await endpointInterface(
      lang,
      'backend',
      'backendVer',
      'get',
      true
    );
    var wait = true;
    if (backendResponse.validResponse) {
      clearInterval(intervalBackendVersion);
      if (backendResponse.data === maintenanceVariable) {
        setIsInMaintenance(true);
        checkMaintenance = true;
        wait = false;
      } else {
        backendErrorCount = 0;
        wait = false;
        if (checkMaintenance) window.location.reload();
      }
    } else backendErrorCount += 1;
    if (backendErrorCount >= 3) {
      setIsBackendDown(true);
      checkMaintenance = true;
    }
    return wait;
  };

  const logStatus = async (returnData = false) => {
    var params = {
      page: window.location.pathname,
      pwa_env: isStandalone || isIOSStandalone ? pwa_env : null,
      pwa_version: isStandalone || isIOSStandalone ? pwa_version : null
    };
    let tmpInfos = await endpointInterface(
      lang,
      'backend',
      'getUserInfo',
      'get',
      true,
      params
    );
    if (!deepEqual(tmpInfos.data, userInfos)) {
      tmpInfos.data['isInCluster'] =
        tmpInfos.data.cluster &&
        Object.keys(tmpInfos.data.cluster).length > 0 &&
        !tmpInfos.data.cluster.is_owner &&
        tmpInfos.data.cluster.id !== traderClusterID;
      setUserInfos(tmpInfos.data);
      // set the userInfos in the sharedState (used for cache)
      sharedState.userInfos = tmpInfos.data;
      // send firebase token to backend
      sendFirebaseToken();
    }
    if (tmpInfos.validResponse) {
      setLoggedIn(true);
    } else {
      if (credentialsPath && tmpInfos.responseStatus !== 401) {
        toast.error(tmpInfos.responseMessage, { closeButton: false });
        setTimeout(() => {
          toast.dismiss();
        }, 5000);
        setLoggedIn(false);
      }
    }
    if (returnData) return tmpInfos.data;
  };

  const updateTitle = () => {
    const defaultTitle = 'Hodlie';
    // Create a URL object to easily extract components from the URL
    const url = new URL(window.location.href);
    // Get pathname without query parameters
    const cleanPathname = url.pathname;
    // Find the corresponding route using the clean pathname
    const currentRoute = frontendRoutes.find(
      route => route.to === cleanPathname
    );
    let routeName;
    // Determine route name based on `currentRoute` existence and format
    if (currentRoute) {
      if (typeof currentRoute.name === 'object') {
        // If `name` is an object, use the italian name first, then the english one
        routeName = currentRoute.name['it-IT'] || currentRoute.name['en-EN'];
      } else {
        // If `name` is not an object, use it directly
        routeName = currentRoute.name;
      }
    } else {
      // If route doesn't exist, format the clean pathname:
      routeName = cleanPathname
        .slice(1)
        .replace(/-/g, ' ') // Replace hyphens with spaces
        .split('/')
        .map(part => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' - ');
    }
    // Set the document title
    const title = `${defaultTitle} | ${routeName}`;
    // Update the document title
    document.title = title;
  };

  useEffect(async () => {
    updateTitle();
    intervalBackendVersion = setInterval(async () => {
      await checkBackendMaintenance();
    }, 5000);
    let wait = await checkBackendMaintenance();
    setTimeout(() => {
      loadedTime.current = loadedTime.current + 1;
    }, 1000);
    if (!wait) {
      await logStatus();
      window.scrollTo(0, 0);
      if (!loadedContent) {
        setTimeout(() => {
          if (hash) {
            const id = hash.replace('#', '');
            const element = document.getElementById(id);
            if (element) {
              element.scrollIntoView({ block: 'start', behavior: 'smooth' });
            }
          }
        }, 0);
        window.scrollTo(0, 0);
        setLoadedContent(true);
      }
    }
  }, [pathname]);

  useEffect(() => {
    if (userInfos && Object.keys(userInfos).length) initClarity(userInfos);
  }, [Object.keys(userInfos).length]);

  const routerComponent = useMemo(
    () => <HodlieRouter logStatus={logStatus} />,
    [userInfos]
  );

  return isClosed ? (
    <div className="container">
      <ClosingPage />
    </div>
  ) : (sharedState.userInfos?.level < teamLevel && isInMaintenance) ||
    isBackendDown ? (
    <ComingSoon
      media={maintenance}
      imgCol={6}
      useImg={false}
      badge={{
        show: true,
        text: textLang.maintenance[lang],
        colorClass: 'secondary'
      }}
      text={textLang.maintenanceText[lang]}
      button={{ show: false }}
      lottieClass="svg-custom"
      cardClass="margin-top-custom"
    />
  ) : !loadedContent ? (
    <div className="center-page">
      <LoadingSpinner subText="Hodlie" useGif={true}></LoadingSpinner>
    </div>
  ) : (
    <>
      {showHeader && <Header setShowHeader={setShowHeader} />}
      <div
        className={
          isFluid ? 'container-fluid' : 'container max-width-container'
        }
      >
        {loggedIn && pathname !== '/form' && (
          <UsetifulScriptLoader userInfos={userInfos} />
        )}
        {bottomNavPath && <NavbarBottom />}
        {verticalNavPath
          ? (navbarPosition === 'vertical' || navbarPosition === 'combo') && (
              <NavbarVertical showHeader={showHeader} />
            )
          : null}
        <div className={classNames('content', { 'pb-0': isKanban })}>
          {topNavPath && <NavbarTop showHeader={showHeader} />}
          <Event />
          {isEventTime &&
            loadedTime.current === 0 &&
            pathname !== '/invest' && (
              <Snowfall
                style={{
                  position: 'fixed',
                  width: '100vw',
                  height: '100vh',
                  zIndex: 10000,
                  animation: 'fade-out 15s forwards' // CSS animation to fade out the component after 3 seconds
                }}
                images={images}
                radius={[10.0, 15.0]}
              />
            )}
          {routerComponent}
          {!isKanban && (
            <span className="d-none d-sm-block">
              <Footer />
            </span>
          )}
        </div>
      </div>
    </>
  );
};

export default MainLayout;
